import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { GatsbyImage } from "gatsby-plugin-image";
import { PrismicRichText } from "@prismicio/react";
import Anchor from "../elements/Anchor";

import "../../styles/components/slices/achievements.scss";

const Achievements = ({ slice }) => {
  if (!slice) return null;

  return (
    <>
      <Container
        fluid
        className="achievements section text-center d-none d-md-block"
      >
        <GatsbyImage
          image={slice.primary.desktop_image.gatsbyImageData}
          alt={slice.primary.desktop_image.alt || "achievements image"}
          className="main-img align-middle"
        />
        {slice.primary.button_label !== null &&
          slice.primary.button_url.url !== null && (
            <div className="book-now-outline mx-auto mt-5 d-none d-lg-block mona">
              <Anchor
                href={slice.primary.button_url.url}
                className="book-now-btn text-center"
                target={slice.primary.button_url.target}
              >
                {slice.primary.button_label}
              </Anchor>
            </div>
          )}
      </Container>

      <Container
        fluid
        className="achievements-mobile max-container py-5 text-center d-block d-md-none"
      >
        <Row>
          {slice.items.map((item, index) => (
            <Col className="col-12" key={index}>
              <div className="d-flex flex-column text-center my-4">
                <GatsbyImage
                  image={item.item_image.gatsbyImageData}
                  alt={item.item_image.alt || "achievements images"}
                  className="icons m-auto"
                />
                <p className="font-s-65 l-h-75 font-w-300">{item.number}</p>
                <PrismicRichText field={item.description.richText} />
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
};

export default Achievements;
